// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// See LICENSE.md for licensing terms.

import type { TourScript } from '@vn-grc/shared';
import { getRouteModule, routeOpensFor } from '../config/route-permissions.js';

/** Pure access projection shared by the live gallery/provider and browser checks. */
export function prepareTourForAccess(
  script: TourScript,
  hasPermission: (permission: string) => boolean,
  isModuleEnabled: (module: string) => boolean,
): TourScript | null {
  if (!isModuleEnabled(script.module) || !(script.required_permissions ?? []).every(hasPermission))
    return null;
  let allowedRoute = true;
  const steps = script.steps.filter((step) => {
    if (step.navigate_to) {
      const route = step.navigate_to.replace(/[?#].*$/, '').replace(/^\/admin\/?/, '');
      const module = getRouteModule(route);
      allowedRoute = routeOpensFor(route, hasPermission) && (!module || isModuleEnabled(module));
    }
    return (
      allowedRoute &&
      (step.required_permissions ?? []).every(hasPermission) &&
      (step.required_modules ?? []).every(isModuleEnabled)
    );
  });
  return steps.length
    ? {
        ...script,
        steps,
        estimated_duration_seconds: Math.round(
          (script.estimated_duration_seconds * steps.length) / script.steps.length,
        ),
        access_filtered: script.access_filtered || steps.length !== script.steps.length,
      }
    : null;
}
